export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyB_LxaMPvcPBeSoW22n0cxNgMTLtgE52AE",
  authDomain: "xxx-portal.firebaseapp.com",
  projectId: "xxx-portal",
  storageBucket: "xxx-portal.appspot.com",
  messagingSenderId: "353455497621",
  appId: "1:353455497621:web:9f1c24782a2920c4c1569c",
  measurementId: "G-8Q9WD4ZTYH"
}
